import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'reactstrap';

const BlogItem = ({ title, author, date, commentsCount, views, content, imageUrl, detailsLink }) => {
  return (
    <Col lg={6} md={12}>
      <div className="item news-slid">
        <Link to={detailsLink}>
          <div className="news-box">
            <img src={imageUrl} alt="news" className="img-fluid" />
          </div>
        </Link>
        <div className="news-text">
          <div className="blog-hover">
            <h4>{title}</h4>
            <ul className="list-inline blog-details-list">
              <li><Link className='text-decoration-none'>{author}</Link></li>
              <li><Link className='text-decoration-none'>{date}</Link></li>
              <li><Link className='text-decoration-none'>{`${commentsCount} comments`}</Link></li>
              <li><Link className='text-decoration-none'>{`${views} View`}</Link></li>
            </ul>
          </div>
          <p>{content}</p>
          <Link to={detailsLink} className="btn-theme text-decoration-none">View more</Link>
        </div>
      </div>
    </Col>
  );
};

export default BlogItem;
